import React from 'react'
import PropTypes from 'prop-types'

import { Column, Row, Section } from '@/components/layout'
import PricingCta from '@/components/PricingCta'
import { Text } from '@/components/common'

const FeaturesFooter = ({
  noPaddingTop = false,
  sectionProps,
  header = 'featuresFooter.header',
  textContent = 'featuresFooter.p',
  customCtaMessage = 'cta.signUpNow',
  textUnderBt,
  btSize = 'large',
  btVariant = 'primary',
}) => (
  <Section style={noPaddingTop ? { paddingTop: 0 } : undefined} {...sectionProps}>
    <Row>
      <Column alignCenter textCenter>
        <Text.H2 messageId={header} />
        <Text.P messageId={textContent} />
        <PricingCta
          className="self-center"
          messageId={customCtaMessage}
          size={btSize}
          variant={btVariant}
        />
        {textUnderBt && <Text.P messageId={textUnderBt} size="small" />}
      </Column>
    </Row>
  </Section>
)

FeaturesFooter.propTypes = {
  noPaddingTop: PropTypes.bool,
  sectionProps: PropTypes.shape({}),
  header: PropTypes.string,
  textContent: PropTypes.string,
  customCtaMessage: PropTypes.string,
  textUnderBt: PropTypes.string,
  btSize: PropTypes.string,
  btVariant: PropTypes.string,
}

export default FeaturesFooter
